import React from 'react'
import { Link } from 'react-router'
import MediaQuery from 'react-responsive'
import { connect } from 'react-redux'
import classes from './Header.scss'
import Title from './menu_title.png'
import Avatar from './avatar3.png'

class Header extends React.Component {
  render () {
    const { username, toggleSidebar, sidebar } = this.props
    const sidebarClasses = ['fa', 'fa-bars', classes.menuIcon, sidebar && classes.active].join(' ')

    return (
      <div className={classes.header}>
        <i className={sidebarClasses} onClick={toggleSidebar}></i>
        <h1><Link to='/home' style={{ textDecoration: 'none' }}><img src={Title} className={classes.titleImage} /></Link></h1>
        <div style={{cursor: 'pointer'}} onClick={() => window.location.href=`/profile/${username}`}>
          <span className={classes.username}>
            <img src={Avatar} className={classes.avatar} />
            <span>{username || 'guest'}</span>
          </span>
        </div>
      </div>
    )
  }
}

export const mapStateToProps = (state: any, ownProps: any): any => {
  return {
    username: state.username,
    sidebar: state.sidebar,
  }
}

export const mapDispatchToProps = (dispatch: Function, ownProps: any): any => {
  return {
    setUsername: (username) => dispatch(setUsername(username)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)



/** WEBPACK FOOTER **
 ** ./src/components/Header/Header.js
 **/